module.exports = __webpack_public_path__ + "78f679f5e8a7673379cc63103dd666b4.pdf";